import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { getPagesList } from 'services/pages';
import { getPagesAccess } from 'utils/permissions/permissions-apply';
import { ContextWrapper } from 'contexts/wrapper.context';

import Header from 'components/Header/Header';
import Container from 'components/Container/Container';
import EmptyState from 'components/Pages/components/EmptyState/EmptyState';
import LoadingWrapper from 'components/LoadingWrapper/LoadingWrapper';
import { notify } from 'components/Notify/Notify';
import PageList from 'components/Pages/components/PagesList/PageList';

const Pages = () => {
  const { formatMessage } = useIntl();

  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState([]);

  const { businessInfo } = useContext(ContextWrapper);

  const fetchPages = async () => {
    setIsLoading(true);

    const payload = {
      limit: 50,
      page: 1
    };

    try {
      const { pages } = await getPagesList(payload);
      setPages(pages);
    } catch (error) {
      notify({ msg: error.message, error });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchPages();
  }, []);

  return (
    <Container
      header={
        <Header
          title={formatMessage({ id: 'pages.header.title' })}
          subTitle={formatMessage({ id: 'pages.header.subtitle' })}
        />
      }
      content={
        <LoadingWrapper loading={isLoading}>
          {pages.length ? (
            <PageList
              pages={pages}
              setIsLoading={setIsLoading}
              setPages={setPages}
            />
          ) : (
            !isLoading && (
              <EmptyState
                permissions={getPagesAccess(businessInfo?.userSllrPermissions)}
              />
            )
          )}
        </LoadingWrapper>
      }
    />
  );
};

export default Pages;
